import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Additional Work Requirements\n          ")
], -1);
const _hoisted_5 = { class: "mt-4" };
const _hoisted_6 = {
    key: 0,
    class: "grid sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n                  DBS Certificate\n                ")
], -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Has the Employee presented you with the Disclosure Certificate confirming the outcome of their DBS/DS check with EQUANS?\n                  Note: this must be an EQUANS Disclosure Check *")
], -1);
const _hoisted_9 = { class: "mt-4 space-y-4" };
const _hoisted_10 = { class: "flex items-start" };
const _hoisted_11 = { class: "h-5 flex items-center" };
const _hoisted_12 = ["checked"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitment-certificate-check-no",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_14 = { class: "flex items-start" };
const _hoisted_15 = { class: "h-5 flex items-center" };
const _hoisted_16 = ["checked"];
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitment-certificate-check-yes",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700 mt-4" }, "Please remember to highlight to your HR Manager where a certificate highlights any\n              concerns and please also note that you must not retain copies of Disclosure Certificates\n              for more than 6 months.\n            ", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", {
    for: "date_of_issue",
    class: "block text-sm font-medium text-gray-700 mt-2"
}, "Date of issue", -1);
const _hoisted_20 = { class: "flex mt-1 rounded-md shadow-sm" };
const _hoisted_21 = ["value", "disabled"];
const _hoisted_22 = { class: "mt4 sm:mt-0 sm:col-span-2" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "\n              Additional Comments:\n            ", -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = {
    key: 1,
    class: "p-3 w-full flex flex-row items-center"
};
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 ml-2" }, "\n            Once submitted, this document will go for re-approval because the terms have changed.\n          ", -1);
const _hoisted_27 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_28 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CheckList = _resolveComponent("CheckList");
    const _component_FileUploader = _resolveComponent("FileUploader");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_CheckList, {
                        options: _ctx.additionalWorkRequirementsOptions,
                        "model-value": _ctx.formData?.additionalRequirements || [],
                        label: "Based on the role and location select the relevant options below:",
                        name: "additionalRequirements",
                        "onUpdate:modelValue": _ctx.handleChecklistChange
                    }, null, 8, ["options", "model-value", "onUpdate:modelValue"])
                ]),
                _createTextVNode(),
                (_ctx.atr?.formEight?.disclosureCheckRequired === 'Yes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_7,
                            _createTextVNode(),
                            _hoisted_8,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("input", {
                                            id: "radio-button-certificate-check-no",
                                            name: "certificate",
                                            type: "radio",
                                            value: "No",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                            checked: _ctx.formData.certificate === 'No',
                                            onChange: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                        }, null, 40, _hoisted_12)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_13
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("input", {
                                            id: "radio-button-certificate-check-yes",
                                            name: "certificate",
                                            type: "radio",
                                            value: "Yes",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer",
                                            checked: _ctx.formData.certificate === 'Yes',
                                            onChange: _cache[1] || (_cache[1] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                        }, null, 40, _hoisted_16)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_17
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_18,
                            _createTextVNode(),
                            (_ctx.formData.certificate === 'Yes')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_FileUploader, {
                                        name: "dbs-certificate",
                                        files: _ctx.formData.files,
                                        disabled: _ctx.disableForm,
                                        "document-short-id": _ctx.atr?.shortId,
                                        uploading: _ctx.uploading,
                                        class: "mt-4",
                                        onUpdateFiles: _ctx.handleUpdateFiles,
                                        onFileUploading: _cache[2] || (_cache[2] = ($event) => (_ctx.uploading = $event))
                                    }, null, 8, ["files", "disabled", "document-short-id", "uploading", "onUpdateFiles"]),
                                    _createTextVNode(),
                                    _createElementVNode("div", null, [
                                        _hoisted_19,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("input", {
                                                id: "date_of_issue-input",
                                                value: _ctx.formData.date_of_issue,
                                                disabled: _ctx.disableForm,
                                                type: "date",
                                                name: "date_of_issue",
                                                class: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-gray-700",
                                                onInput: _cache[3] || (_cache[3] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                            }, null, 40, _hoisted_21)
                                        ])
                                    ])
                                ], 64))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(),
                    _createElementVNode("textarea", {
                        id: "offer_comments-input",
                        value: _ctx.formData.offer_comments,
                        name: "offer_comments",
                        rows: "3",
                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                        onInput: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                    }, null, 40, _hoisted_24)
                ]),
                _createTextVNode(),
                (_ctx.forReapproval)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_ExclamationIcon, { class: "text-red-600 h-16 w-16" }),
                        _createTextVNode(),
                        _hoisted_26
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (_ctx.document.currentStageName === 'offer.notifyPrepOffer')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.disableComplete,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.completeOffer && _ctx.completeOffer(...args)), ["prevent"]))
                    }, "\n          Complete Offer\n        ", 8, _hoisted_28)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
